module.exports = __webpack_public_path__ + "resources/img/img_credit_event1.5a5d8698e22857f177397a2891ef5462.png";